import Modal from "react-modal";
import closeLogo from "../assets/images/atrapame-si-puedes/close-item.svg";
import {useTranslation} from "react-i18next";

Modal.setAppElement("#root");

export const DialogTerms = ({isOpen, toggleModal}) => {
  const {t} = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={toggleModal}
      contentLabel="My dialog"
      className="asp-modal-terms"
      closeTimeoutMS={200}
    >
      <img
        className="asp-modal-terms-close"
        src={closeLogo}
        alt="Close Button"
        onClick={toggleModal}
      />
      <div className="asp-modal-terms-container">
        <div className="asp-modal-terms-title">{t("atrapaqr.modal.title")}</div>
        <div className="asp-modal-terms-container-content">
          <p className="asp-modal-terms-container-text">
            {t("atrapaqr.modal.paragraph1")}
          </p>
          <p className="asp-modal-terms-container-text">
            <strong>{t("atrapaqr.modal.paragraph2Strong")}</strong>
            <br />
            {t("atrapaqr.modal.paragraph2")}
          </p>
          <p className="asp-modal-terms-container-text">
            <strong>{t("atrapaqr.modal.paragraph3Strong")}</strong>
            <br />
            {t("atrapaqr.modal.paragraph3")}
          </p>
          <p className="asp-modal-terms-container-text">
            {t("atrapaqr.modal.paragraph4")}
          </p>
          <ol className="asp-modal-term-container-list">
            <li>
              <span class="asp-modal-terms-container-list-number">
                {t("atrapaqr.modal.list.number1")}
              </span>
              <span class="asp-modal-terms-container-text">
                {t("atrapaqr.modal.list.text1")}
              </span>
            </li>
            <li>
              <span class="asp-modal-terms-container-list-number">
                {t("atrapaqr.modal.list.number2")}
              </span>
              <span class="asp-modal-terms-container-text">
                {t("atrapaqr.modal.list.text2")}
              </span>
            </li>
            <li>
              <span class="asp-modal-terms-container-list-number">
                {t("atrapaqr.modal.list.number3")}
              </span>
              <span class="asp-modal-terms-container-text">
                {t("atrapaqr.modal.list.text3")}
              </span>
            </li>
          </ol>
          <p className="asp-modal-terms-container-text">
            <strong>{t("atrapaqr.modal.paragraph5Strong")}</strong>
            <br />
            {t("atrapaqr.modal.paragraph5")}
          </p>
          <p className="asp-modal-terms-container-text">
            {t("atrapaqr.modal.paragraph6")}
          </p>
          <p className="asp-modal-terms-container-text">
            <strong>{t("atrapaqr.modal.paragraph7Strong")}</strong>
            <br />
            {t("atrapaqr.modal.paragraph7")}
          </p>
          <p className="asp-modal-terms-container-text">
            {t("atrapaqr.modal.paragraph8")}
          </p>
          <p className="asp-modal-terms-container-text">
            {t("atrapaqr.modal.paragraph9")}
          </p>
        </div>
      </div>
    </Modal>
  );
};
